module.exports = __webpack_public_path__ + "static/gem-extendedoffer-vertical-db44cbcf114b84316309f0589b7ad490.png";